import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
  TableRow,
} from '@mui/material';
import AzureSearchServicesTableHead from './AzureSearchServiceHead';
import AzureSearchServiceMenu from './AzureSearchServiceMenu';
import { AzureSearchService } from '../Model/AzureSearchServiceModel';
import { getSorting, stableSort } from '../../../../Helpers/UtilityMethods';
import { Order } from '../../../../Helpers/Literals';

interface Props {
  classes: Record<string, string>;
  order: Order;
  orderBy: keyof AzureSearchService;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof AzureSearchService,
  ) => void;
  page: number;
  rowsPerPage: number;
  services: AzureSearchService[];
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => void;
  onDelete: (name: string) => void;
}

const ShowAzureSearchServiceData: React.FC<Props> = ({
  classes,
  order,
  orderBy,
  onRequestSort,
  page,
  rowsPerPage,
  services,
  onPageChange,
  onDelete,
}) => {
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, services.length - page * rowsPerPage);

  return (
    <div className={classes.tableWrapper}>
      <Table className={classes.table}>
        <AzureSearchServicesTableHead
          order={order}
          orderBy={orderBy}
          onRequestSort={onRequestSort}
        />
        <TableBody>
          {stableSort(services, getSorting(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((sa) => (
              <TableRow key={sa.Name}>
                <TableCell
                  component="th"
                  scope="row"
                  className={classes.subDomainWidth}
                >
                  {sa.Name}
                </TableCell>
                <TableCell>{sa.ResourceGroup}</TableCell>
                <TableCell>{sa.Subscription}</TableCell>
                <TableCell>{sa.ProductID}</TableCell>
                <TableCell>{sa.AzureRegion}</TableCell>
                <TableCell style={{ width: 100 }} align="left">
                  <AzureSearchServiceMenu
                    Name={sa.Name}
                    DeleteFunction={onDelete}
                  />
                </TableCell>
                <TableCell />
              </TableRow>
            ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={8} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[8]}
              colSpan={8}
              count={services.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'Rows per page' },
                native: true,
              }}
              onPageChange={onPageChange}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </div>
  );
};

export default ShowAzureSearchServiceData;
